import ApiService from "./../api/ApiService";
import Urls from "./../api/Urls";
import Config from "../constants/Config";
import Inventory from "../models/Inventory";
import {
  parseInventoryListReponseParams,
  parseTourListReponseParams,
} from "../utils/commonUtils";
import { isEmpty } from "lodash";
import InventorySalePlanMode from "models/InventorySalePlanMode";

export function getGoodReceiptCode() {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.GET_WAREHOUSE_GOOD_RECEIPT_CODE,
  }).get();
}

export function getListGoodReceipt(params = {}) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.GET_LIST_WAREHOUSE_GOOD_RECEIPT,
    params: params,
    parser: goodReceiptDataParser,
  }).get();
}

export function createGoodReceiptCode(inventory) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.CREATE_WAREHOUSE_GOOD_RECEIPT,
  }).post(inventory);
}

export function updateGoodReceiptCode(inventory) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.CREATE_WAREHOUSE_GOOD_RECEIPT,
  }).put(inventory);
}

export function deleteGoodReceiptCode(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.GET_WAREHOUSE_GOOD_RECEIPT,
    endpointParams: { id },
  }).delete();
}

export function getWareHouseDetail(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.GET_WAREHOUSE_GOOD_RECEIPT,
    endpointParams: { id },
    parser: (data) => new Inventory(data),
  }).get();
}


export function getSalePlanMode(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_GET_SALE_PLAN_MODE,
    endpointParams: { id },
    parser: (data) => new InventorySalePlanMode(data),
  }).get();
}


const goodReceiptDataParser = (data) => {
  if (isEmpty(data.result)) {
    return { inventory: [], ...parseInventoryListReponseParams(data) };
  }
  return {
    inventory: (data.result || []).map((item) => new Inventory(item)),
    ...parseInventoryListReponseParams(data),
  };
};

//   data.data ? ({
//   inventory: (data.data.result || []).map(item => new Inventory(item)),
//   ...parseTourListReponseParams(data.data),
// }) : { inventory: [] }};
